module.exports = __webpack_public_path__ + "img/sidebar.bfa67724.png";